<template>
  <div class="bus" ref="bus">
    <h1>主营业务</h1>
    <img :src="require('@/assets/homes/text1.png')" alt="" />
  </div>
</template>

<script setup>
import { reactive, defineProps, watch, ref } from "vue";

const bus = ref("");

const props = defineProps({
  InitialIndex: String,
});
watch(
  () => props.InitialIndex,
  () => {
    if (props.InitialIndex == "2") {
      bus.value.style.transform = "translateX(0)";
      bus.value.style.opacity = "1";
    }
  }
);
</script>

<style lang="less" scoped>
.bus {
  box-sizing: border-box;
  height: 100%;
  padding: 10px 10%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  transition: all 1.5s ease;
  transform: translateX(-100%);
  opacity: 0;

  h1 {
    display: inline-block;
    box-sizing: border-box;
    padding: 0px 20px 10px 0;
    margin-right: 50%;
    border-bottom: 2px solid gray;
  }

  img {
    width: 100%;
  }
}
</style>
